import Vue from 'vue';

const customerCategoriesRepository = {
  all: () => Vue.$axios.get(`customer-categories/list`)
  .then(({data}) => data, (error) => console.log(error)),
};

export default customerCategoriesRepository;
